<template>
  <template v-if="!isLoading">
    <AcademicLayout>
      <template #title>
        Primary
      </template>

      <template #header>
        <a v-for="each in payload" :key="each.id" :href="`#${each.id}`" class="btn me-3 rounded-pill">
          {{ each.intake }}
        </a>
      </template>

      <template #body>
        <div class="row label-bar">
          <div class="col-6">
            <div class="label py-3 text-uppercase text-center">
              intake
            </div>
          </div>
          <div class="col-6">
            <div class="label py-3 text-uppercase">area of learning</div>
          </div>
        </div>
        <Area v-for="(area, index) in payload" :area="area" :key="index" />
      </template>
    </AcademicLayout>
  </template>
  <template v-if="isLoading">
    <div>
      Loading...
    </div>
  </template>
</template>

<script>
import Area from '@/components/Academic/Area.vue'
import courseService from "@/services/courseApi"
import AcademicLayout from '@/views/academic/AcademicLayout.vue'
import { courseConstant } from "@/constants/index"

export default {
  components: {
    Area,
    AcademicLayout,
  },
  data() {
    return {
      isLoading: true,
      payload: [],
      // Static replacement for the backend course with id 8 (intake "Grade 2 & 3").
      // It is displayed as two separate intakes - Grade 2 and Grade 3 - with the same curriculum.
      staticCourses: [
        {
          id: 8,
          intakes: [
            {
              id: '8-grade-2',
              intake: 'Grade 2',
              curriculum: [
                { title: 'Myanmar National Curriculum', lists: ['Myanmar', 'English', 'Mathematics', 'Science', 'Social Studies', 'Moral', 'Life Skills'] },
                { title: 'Co-Curricular Subjects & Activities', lists: ['English', 'Mathematics', 'Science', 'Computing', 'Social Studies', 'STEM (Science, Technology, Engineering & Math)'] },
                { title: 'Foreign Language (Choose One)', lists: ['Chinese', 'Japanese'] },
                { title: 'Enrichment Programme', lists: ['Leader in Me & Character Education'] },
                { title: 'Extra-Curricular Activities', lists: ['Arts', 'Physical Education', 'Music Education', 'Yoga'] },
                { title: 'Extended Learning Platform for Skills Enhancement', lists: ['English, Mathematics, Science & Coding'] },
              ],
            },
            {
              id: '8-grade-3',
              intake: 'Grade 3',
              curriculum: [
                { title: 'Myanmar National Curriculum', lists: ['Myanmar', 'English', 'Mathematics', 'Science', 'Social Studies', 'Moral', 'Life Skills'] },
                { title: 'Co-Curricular Subjects & Activities', lists: ['English', 'Mathematics', 'Science', 'Computing', 'Social Studies', 'STEM (Science, Technology, Engineering & Math)'] },
                { title: 'Foreign Language (Choose One)', lists: ['Chinese', 'Japanese'] },
                { title: 'Enrichment Programme', lists: ['Leader in Me & Character Education'] },
                { title: 'Extra-Curricular Activities', lists: ['Arts', 'Physical Education', 'Music Education', 'Yoga'] },
                { title: 'Extended Learning Platform for Skills Enhancement', lists: ['English, Mathematics, Science & Coding'] },
              ],
            },
          ],
        },
      ],
      fetchPayload: {
        params: {
          type: courseConstant.classTypes[0],
          level: courseConstant.yearLevels['one'][1]
        }
      }
    }
  },
  methods: {
    async fetchCourses() {
      let res = await courseService.getCourses(this.fetchPayload)
      const courses = []
      const matchedStaticIds = []
      res.forEach(each => {
        const staticCourse = this.staticCourses.find(sc => sc.id == each.id)
        if (staticCourse) {
          // Show the static entries instead of the backend data
          matchedStaticIds.push(staticCourse.id)
          staticCourse.intakes.forEach(intake => {
            courses.push({
              ...each,
              id: intake.id,
              intake: intake.intake,
              curriculum: intake.curriculum,
            })
          })
        } else {
          each.curriculum = JSON.parse(each.curriculum)
          courses.push(each)
        }
      })
      // Still show the static courses when the backend record is missing
      this.staticCourses.forEach(staticCourse => {
        if (!matchedStaticIds.includes(staticCourse.id)) {
          staticCourse.intakes.forEach(intake => {
            courses.push({
              id: intake.id,
              intake: intake.intake,
              curriculum: intake.curriculum,
              fromMonth: 'June',
              toMonth: 'June',
            })
          })
        }
      })
      this.payload = courses
    },
  },
  async mounted() {
    this.isLoading = true
    try {
      await this.fetchCourses()
    } catch (err) {
      console.log(err)
    } finally {
      this.isLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  background-color: var(--cus-white);
  min-width: 200px;
  flex-shrink: 0;
  text-transform: uppercase;
  color: var(--cus-primary)
}

.label-bar {
  background-color: var(--cus-grey);
  border-bottom: 1px solid #808080;

  .label {
    font-size: var(--cus-fs-large);
    color: var(--cus-secondary-bold);
    font-weight: var(--cus-fw-semibold);
  }
}
</style>